import { render } from "./BookingSharePanel.vue?vue&type=template&id=0bd31e3a&scoped=true"
import script from "./BookingSharePanel.vue?vue&type=script&lang=js"
export * from "./BookingSharePanel.vue?vue&type=script&lang=js"

import "./BookingSharePanel.vue?vue&type=style&index=0&id=0bd31e3a&scoped=true&lang=css"

import exportComponent from "C:\\MartinRud-CloudRoot\\Firma\\Code\\PHP\\byensegenbil.dk\\byensegenbil.dk-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd31e3a"]])

export default __exports__